const gaTrackEvent = (eventCategory, eventAction, eventLabel) => {
  eventCategory = eventCategory || ''
  eventAction = eventAction || ''
  eventLabel = eventLabel || ''
  if (window.ga) {
    window.ga('send', 'event', eventCategory, eventAction, eventLabel)
  }
}

export default {
  gaTrackEvent,
}